import Breadcrumb from '@/components/base/Breadcrumb';
import ContactForm from '@/pages/contact/components/ContactForm';

const contactItems = [
  { icon: 'ri-map-pin-2-line', title: '公司地址', value: '北京市朝阳区建国路 88 号 网址大全大厦 12 层' },
  { icon: 'ri-mail-line', title: '联系邮箱', value: 'hello@wangzhidaquan.com' },
  { icon: 'ri-phone-line', title: '联系电话', value: '400-000-8888（工作日 9:00 - 18:00）' },
  { icon: 'ri-time-line', title: '服务时间', value: '周一至周五 9:00 - 18:00，节假日休息' },
];

export default function ContactPage() {
  return (
    <div className="w-full animate-fade-in px-4 py-6 md:px-8 md:py-10">
      <div className="mx-auto max-w-[1080px]">
        <Breadcrumb items={[{ label: '联系我们' }]} />

        <header className="mt-4">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">联系我们</h1>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            想要推荐优质网站、反馈内容问题，或洽谈合作？填写下方表单或通过以下方式联系我们，我们会尽快回复。
          </p>
        </header>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
          <ContactForm />

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                联系方式
              </h2>
              <ul className="mt-4 space-y-4">
                {contactItems.map((item) => (
                  <li key={item.title} className="flex items-start gap-3">
                    <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${item.icon} text-base`}></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{item.title}</p>
                      <p className="mt-0.5 text-sm text-foreground-800">{item.value}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <iframe
                title="网址大全公司位置地图"
                src="https://maps.google.com/maps?q=Beijing%20Chaoyang%20Jianguo%20Road%2088&z=14&output=embed"
                className="h-[260px] w-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                aria-label="公司位置地图"
              ></iframe>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}